import React, { useState } from "react";
import { formatRelativeDate } from "../../utils/misc";

const getInitials = (name) =>
  name
    ? name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join("")
    : "";

function ReportComment({ comment, ...props }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="w-full flex items-start gap-3">
      {/* Profile Image */}
      {comment.profilePhotoLink && !imgError ? (
        <img
          src={comment.profilePhotoLink}
          alt=""
          className="object-cover w-[32px] h-[32px] rounded-full flex-shrink-0"
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          className="rounded-full flex justify-center items-center w-[32px] h-[32px] flex-shrink-0"
          style={{
            background:
              "linear-gradient(267.39deg, #FF60B6 0.32%, #2960FD 100.25%)",
          }}
        >
          <p className="text-xs font-normal text-white">
            {getInitials(comment.details?.name)}
          </p>
        </div>
      )}

      {/* Comment Content Container */}
      <div className="flex-1 flex flex-col gap-1">
        {/* Comment Text */}
        <p className="dark:text-[#D9D9D9] text-gray-700 font-normal text-base leading-relaxed break-words">
          {comment.content || "Lorem ipsum is a dummy text company."}
        </p>

        {/* Meta (Name + Time) */}
        <div className="flex items-center gap-2 text-xs text-gray-400 dark:text-gray-400">
          <span className="font-normal">
            {comment.details?.name || "John Doe"}
          </span>
          <span>
            {formatRelativeDate(comment.createdAt) || "Today, 10:45 AM"}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ReportComment;